<template>
  <div id="app">
    <main id="upload-donations-app">
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
  </div>
</template>
<script lang='ts'>
    import Vue from 'vue';
    // @ts-ignore
    import { FadeTransition } from 'vue2-transitions';
    import '@/assets/uploadDonations/common.css';

    export default Vue.extend({
        components: {
            FadeTransition,
        },
    });
</script>
